import * as React from 'react';
import { Trans } from 'react-i18next';

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export enum Categories {
	All			= "MODULE_CATEGORY_ALL",
	Images		= "MODULE_IMAGES",
	Shapes		= "MODULE_CATEGORY_SHAPES",
	Transforms	= "MODULE_CATEGORY_TRANSFORMS",
	//Generators	= "MODULE_CATEGORY_GENERATORS",
	Effects		= "MODULE_CATEGORY_EFFECTS",
}

export enum ModuleTypes {
	Image							= "MODULE_TYPE_IMAGE",
	ImageUpload						= "MODULE_TYPE_IMAGE_LIBRARY",
	Circle							= "MODULE_TYPE_CIRCLE",
	Rectangle						= "MODULE_TYPE_RECTANGLE",
	Polygon							= "MODULE_TYPE_POLYGON",
	Tartan							= "MODULE_TYPE_TARTAN",
	Chevron							= "MODULE_TYPE_CHEVRON",
	WallpaperGroups					= "MODULE_TYPE_WALLPAPERGROUPS",
	Kaleidoscope					= "MODULE_TYPE_KALEIDOSCOPE",
	BrightnessContrast				= "MODULE_TYPE_BRIGHTNESSCONTRAST",
	Hue								= "MODULE_TYPE_HUE",
	Saturation						= "MODULE_TYPE_SATURATION",
	Vibrance						= "MODULE_TYPE_VIBRANCE",
	Gameboy							= "MODULE_TYPE_GAMEBOY",
	Pixelate						= "MODULE_TYPE_PIXELATE",
	Noise							= "MODULE_TYPE_NOISE",
	PatternDesignService 			= "MODULE_TYPE_PATTERNDESIGNSERVICE",
}
let ModuleInfo:{[key in ModuleTypes]?:{
	name?: React.ReactNode
	type: ModuleTypes
	category: Categories
	description?: React.ReactNode
	transformer: boolean
}} = {};

ModuleInfo[ModuleTypes.Image] = {
	name: <T>Image</T>,
	type: ModuleTypes.Image,
	category: Categories.Images,
	transformer: true,
}

ModuleInfo[ModuleTypes.PatternDesignService] = {
	type: ModuleTypes.PatternDesignService,
	category: Categories.Images,
	transformer: false,
	name: <T>Pattern Design</T>,
}

ModuleInfo[ModuleTypes.WallpaperGroups] = {
	name: <T>Repeat Patterns</T>,
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	description: <T>Tiles the layer using one of the wallpaper groups</T>,
	transformer: false,
}

ModuleInfo[ModuleTypes.Circle] = {
	name: <T>Circle</T>,
	type: ModuleTypes.Circle,
	category: Categories.Shapes,
	description: <T>A circle</T>,
	transformer: true,
}

ModuleInfo[ModuleTypes.Rectangle] = {
	name: <T>Rectangle</T>,
	type: ModuleTypes.Rectangle,
	category: Categories.Shapes,
	description: <T>A circle</T>,
	transformer: true,
}

ModuleInfo[ModuleTypes.Polygon] = {
	name: <T>Polygon</T>,
	type: ModuleTypes.Polygon,
	category: Categories.Shapes,
	description: <T>A polygon</T>,
	transformer: true,
}

/*
ModuleInfo[ModuleTypes.Tartan] = {
	name: <T>Tartan</T>,
	type: ModuleTypes.Tartan,
	category: Categories.Generators,
	description: <T>A tartan design</T>,
	transformer: false,
}

ModuleInfo[ModuleTypes.Chevron] = {
	name: <T>Chevron</T>,
	type: ModuleTypes.Chevron,
	category: Categories.Generators,
	description: <T>A chevron design</T>,
	transformer: false,
}
*/


ModuleInfo[ModuleTypes.Kaleidoscope] = {
	name: <T>Kaleidoscope</T>,
	type: ModuleTypes.Kaleidoscope,
	category: Categories.Transforms,
	description: <T>Adds a kaleidoscope effect to the layer</T>,
	transformer: false,
}

ModuleInfo[ModuleTypes.BrightnessContrast] = {
	name: <T>Brightness & Contrast</T>,
	type: ModuleTypes.BrightnessContrast,
	category: Categories.Effects,
	description: <T>Adds controls for brightness/contrast to the layer</T>,
	transformer: false,
}

ModuleInfo[ModuleTypes.Hue] = {
	name: <T>Hue</T>,
	type: ModuleTypes.Hue,
	category: Categories.Effects,
	description: <T>Adds controls for hue to the layer</T>,
	transformer: false,
}

ModuleInfo[ModuleTypes.Saturation] = {
	name: <T>Saturation</T>,
	type: ModuleTypes.Saturation,
	category: Categories.Effects,
	description: <T>Adds controls for saturation to the layer</T>,
	transformer: false,
}

/*
ModuleInfo[ModuleTypes.Vibrance] = {
	name: <T>Vibrance</T>,
	type: ModuleTypes.Vibrance,
	category: Categories.Effects,
	description: <T>Adds controls for vibrance to the layer</T>,
	transformer: false,
}
*/
/*
ModuleInfo[ModuleTypes.Gameboy] = {
	name: <T>Gameboy</T>,
	type: ModuleTypes.Gameboy,
	category: Categories.Effects,
	description: <T>Adds a retro gameboy palette effect to the layer</T>,
	transformer: false,
}
*/
ModuleInfo[ModuleTypes.Pixelate] = {
	name: <T>Pixelate</T>,
	type: ModuleTypes.Pixelate,
	category: Categories.Effects,
	description: <T>Pixelates the layer</T>,
	transformer: false,
}
/*
ModuleInfo[ModuleTypes.Noise] = {
	name: <T>Noise</T>,
	type: ModuleTypes.Noise,
	category: Categories.Effects,
	description: <T>Adds noise to the layer</T>,
	transformer: false,
}
*/

export default ModuleInfo
